import { useQuery } from '@tanstack/react-query';
import LocalAPI from 'utils/LocalAPI';
import { normalizeId } from '../utils/idNormalization';

// Define query keys for collapse state
export const collapseKeys = {
  all: ['collapse'],
  codeBooks: () => [...collapseKeys.all, 'codebook'],
  codeBook: (projectId) => [...collapseKeys.codeBooks(), normalizeId(projectId)],
  codeBars: () => [...collapseKeys.all, 'codebar'],
  codeBar: (projectId) => [...collapseKeys.codeBars(), normalizeId(projectId)]
};

/**
 * Hook to fetch and manage code book collapse state
 * @param {string|number} projectId - The project ID
 * @returns {Object} Query result with collapse state data
 */
export function useCodeBookCollapseState(projectId) {
  const normalizedProjectId = normalizeId(projectId);

  return useQuery({
    queryKey: collapseKeys.codeBook(normalizedProjectId),
    queryFn: () => LocalAPI.getCodeBook(projectId),
    enabled: !!projectId,
    staleTime: Infinity, // Local storage data doesn't go stale
    gcTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}

/**
 * Hook to fetch and manage code bar collapse state
 * @param {string|number} projectId - The project ID
 * @returns {Object} Query result with collapse state data
 */
export function useCodeBarCollapseState(projectId) {
  const normalizedProjectId = normalizeId(projectId);

  return useQuery({
    queryKey: collapseKeys.codeBar(normalizedProjectId),
    queryFn: () => LocalAPI.getCodeBar(projectId),
    enabled: !!projectId,
    staleTime: Infinity, // Local storage data doesn't go stale
    gcTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}